import React, { useEffect, useState } from "react";
import { UserX, CreditCard, Car, Clock, Repeat, HelpCircle, MoreHorizontal, Send, Settings, CheckCircle2, XCircle, MessageSquare, Paperclip, Lock, UserCheck } from "lucide-react";
import { api } from "../../lib/api";

export const CATS = [
  ["cliente_assente", "Cliente assente", "Il cliente non si presenta", UserX],
  ["pagamento", "Problema di pagamento", "Cash, carta, fattura, importo", CreditCard],
  ["veicolo", "Problema veicolo", "Guasto, spia, incidente", Car],
  ["ritardo", "Ritardo", "Traffico, imprevisto", Clock],
  ["modifica", "Modifica servizio", "Variazione percorso, orario, fermata", Repeat],
  ["info", "Richiesta informazioni", "Indirizzo, contatto, note", HelpCircle],
  ["altro", "Altro", "Altro tipo di richiesta", MoreHorizontal],
];
export const CAT_LABEL = Object.fromEntries(CATS.map(c => [c[0], c[1]]));
export const PRIO = { info: ["Informativa", "bg-sky-400"], normale: ["Normale", "bg-[#E9C46A]"], urgente: ["Urgente", "bg-rose-500"] };
export const STATUS_CLS = {
  "Da gestire": "bg-[#E9C46A] text-black",
  "In lavorazione": "bg-[#2F6BFF] text-white",
  Risolta: "bg-emerald-500 text-black",
  Respinta: "bg-rose-600/90 text-white",
};
export const fmtDT = (iso) => iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";
export const fmtT = (iso) => iso ? new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : "";
export const newClientId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export function Attachment({ rid, a }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let u = null;
    api.get(`/driver-requests/${rid}/attachments/${a.id}`, { responseType: "blob" }).then(r => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setErr(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [rid, a.id]);
  if (err) return <div className="w-24 h-20 rounded-lg border border-rose-500/30 text-[10px] text-rose-300 flex items-center justify-center p-1 text-center">Non disponibile</div>;
  if (!url) return <div className="w-24 h-20 rounded-lg bg-white/5 animate-pulse" />;
  if (a.kind === "image") return <a href={url} target="_blank" rel="noreferrer" data-testid={`att-${a.id}`}><img src={url} alt={a.name} className="w-24 h-20 object-cover rounded-lg border border-white/10" /></a>;
  if (a.kind === "video") return <video src={url} controls className="w-48 h-28 rounded-lg border border-white/10 bg-black" data-testid={`att-${a.id}`} />;
  return <audio src={url} controls className="w-60" data-testid={`att-${a.id}`} />;
}

const EV_ICON = { created: Send, message: MessageSquare, status: Settings, assigned: UserCheck, attachment: Paperclip, note: Lock };

export function Timeline({ req, office }) {
  const evs = req.events || [];
  return (
    <ol className="space-y-3" data-testid="req-timeline">
      {evs.map(e => {
        const closed = e.type === "status" && ["Risolta", "Respinta"].includes(e.status_to);
        const I = closed ? (e.status_to === "Risolta" ? CheckCircle2 : XCircle) : EV_ICON[e.type] || Settings;
        const who = e.author_role === "driver" ? (office ? req.driver_name : "Tu") : (office ? e.author_name : "Ufficio");
        const head = e.type === "created" ? "Richiesta inviata" : e.type === "status" ? e.status_to : e.type === "assigned" ? "Presa in carico" : e.type === "attachment" ? "Allegato aggiunto" : e.type === "note" ? "Nota interna" : "Messaggio";
        return (
          <li key={e.id} className={`flex gap-3 ${e.internal ? "opacity-90" : ""}`} data-testid={`ev-${e.type}`}>
            <span className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${closed && e.status_to === "Risolta" ? "bg-emerald-500 text-black" : e.internal ? "bg-slate-700 text-slate-200" : e.author_role === "driver" ? "bg-[#E9C46A] text-black" : "bg-[#2F6BFF] text-white"}`}><I size={15} /></span>
            <div className={`min-w-0 flex-1 ${e.internal ? "rounded-lg border border-dashed border-slate-600 p-2" : ""}`}>
              <div className="text-[11px] text-slate-400"><span className="font-mono-num text-slate-300">{fmtDT(e.at)}</span> · {who}</div>
              <div className={`text-[13px] font-semibold ${closed && e.status_to === "Risolta" ? "text-emerald-300" : e.type === "status" ? "text-sky-300" : "text-white"}`}>{head}{e.internal && " · solo ufficio"}</div>
              {e.type === "created" && <div className="text-[12px] text-[#E9C46A]">{CAT_LABEL[req.category]}</div>}
              {e.text && <div className="text-[13px] text-slate-200 whitespace-pre-wrap break-words">{e.text}</div>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
